import { ReactNode } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks/hooks";
import { Navigate, useLocation } from "react-router-dom";
import { decodeAccessTokenIfValid } from "@/utils/verifyToken";
import { TUser } from "@/types/types";
import { logOut } from "@/redux/feature/auth/authSlice";
import AuthBootSplash from "@/components/common/AuthBootSplash";

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { token } = useAppSelector((state) => state.auth);
  const rehydrated = useAppSelector(
    (state) =>
      (state.auth as { _persist?: { rehydrated?: boolean } })._persist
        ?.rehydrated ?? false,
  );
  const location = useLocation();
  const dispatch = useAppDispatch();
  const role = "creator";
  const redirect = encodeURIComponent(location.pathname + location.search);

  if (!rehydrated) {
    return <AuthBootSplash />;
  }

  if (!token) {
    return <Navigate replace to={`/auth/sign-in?redirect=${redirect}`} />;
  }

  const user = decodeAccessTokenIfValid(token) as TUser | null;
  if (!user) {
    dispatch(logOut());
    return <Navigate replace to={`/auth/sign-in?redirect=${redirect}`} />;
  }

  if (role !== undefined && user.role !== role) {
    dispatch(logOut());
    return <Navigate replace to={`/auth/sign-in?redirect=${redirect}`} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
